/**
 * Entscheidet, was `document-preview` tut, sobald die signierte URL da ist
 * (Spec 09, AK-520): ein darstellbarer Typ öffnet sich im Betrachter (neuer
 * Tab), ein nicht darstellbarer Typ löst stattdessen einen Download aus —
 * nie eine leere Fläche. Reine Funktion, eigenes Modul — leichter zu testen
 * als eingebettet in `DocumentSheet.tsx` (dieselbe Aufteilung wie
 * `document-form.ts`).
 *
 * Nicht die Zulassungsliste der Ablage (`DOCUMENT_ALLOWED_MIME_TYPES`,
 * AK-500 verbietet sie als Literal) — eine reine Darstellungsfrage: Welche
 * der fünf erlaubten Dateiarten kann ein Browser **inline** zeigen. HEIC und
 * TIFF öffnet kein verbreiteter Browser nativ.
 */

const PREVIEWABLE_MIME_TYPES = new Set(['application/pdf', 'image/jpeg', 'image/png'])

export type DocumentPreviewAction =
  | { readonly kind: 'open'; readonly url: string }
  | { readonly kind: 'download'; readonly url: string; readonly filename: string }

export function isDocumentPreviewable(mimeType: string): boolean {
  return PREVIEWABLE_MIME_TYPES.has(mimeType)
}

/** Beschriftung von `document-preview` — „Ansehen" für darstellbare Typen,
 * sonst „Herunterladen" (AK-520). */
export function documentPreviewLabel(mimeType: string): string {
  return isDocumentPreviewable(mimeType) ? 'Ansehen' : 'Herunterladen'
}

/** `url` ist die signierte Download-URL, `filename` der Dateiname des
 * erzeugten Downloadlinks (`document.title`). */
export function resolveDocumentPreviewAction(mimeType: string, url: string, filename: string): DocumentPreviewAction {
  if (isDocumentPreviewable(mimeType)) return { kind: 'open', url }
  return { kind: 'download', url, filename }
}
